<template>
	<aside class="info-popup card">
		<Button class="close-btn" :action="close" />
		<h1 class="popup-title">{{ title }}</h1>
		<div class="scrolling-content wysiwyg-content" v-html="info_text" />
	</aside>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/base/Button";

export default {
	name: 'BudgetInfoPopup',
	components: {
		Button,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		info_text: {
			type: String,
			required: true,
		},
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		close() {
			this.deactivateModal();
			this.$store.dispatch("sound/fx/play", { id: "generic_wipe" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.info-popup.card {
		align-items: center;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		overflow: hidden;
		background-image: url('~@/assets/images/budget-info-background.svg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		height: 70vh;
		width: 70vw;
		padding-top: 10%;
		position: relative;
		z-index: 10000;

		@include tablet {
			height: 50vh;
			width: 60vw;
			padding-top: 10%;
		}

		@include desktop {
			height: 500px;
			width: 900px;
			padding-top: 125px;
		}
	}

	.popup-title {
		color: $primary-color;
		text-transform: uppercase;
		font-size: $font-size-xx-lg;

		@include tablet { font-size: $heading-size-base; }
		@include desktop { font-size: $heading-size-lg; }
	}

	.scrolling-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
		position: relative;
		color: $off-white-dark;
		font-family: $body-font-alt;
		overflow: auto;
		width: 70%;
		z-index: 1;

		* {
			margin-left: auto;
			margin-right: auto;
		}
	}

	.close-btn {
		position: absolute;
		top: 10%;
		right: 10%;

		@include desktop { top: 15%; }
	}

	@include mobile {
		::-webkit-scrollbar {
			-webkit-appearance: none;
			width: 7px;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px;
		}
	}

	@include tablet {
		::-webkit-scrollbar {
			-webkit-appearance: none;
			width: 7px;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/game/budget/BudgetInfoPopup.vue